"use strict";

import React, {Component} from "react";


export default class ConfirmTemplate extends Component {

    static injectedProps = {
        "style": "ConfirmTemplate"
    };
    static injectedPropTypes = {
        "style": "style",
        "content": "any"
    };

    render() {
        return <div className={this.props.containerClass}>
            {this.props.content}
            {this.props.children}

        </div>
    }
}


/** WEBPACK FOOTER **
 ** ./src/templates/ConfirmTemplate.jsx
 **/